import { createFileRoute } from '@tanstack/react-router';
import { TeamRiskPage } from '@/features/team/pages/team-risk-page';

export const Route = createFileRoute('/_app/team/risk')({ component: TeamRiskPage });
